// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/EngineerPerformanceGrid.js
//
// Purpose:
// Engineer Performance Grid
//
// Uses:
// DashboardCard
// ======================================================================

import React from "react";

import DashboardCard
  from "./DashboardCard";

export default function EngineerPerformanceGrid({

  data = [],

  onEngineerClick,

}) {

  return (

    <DashboardCard

      title="Engineer Performance"

      subtitle="Engineer productivity and SLA metrics"

      height={450}

    >

      <div
        style={{
          overflow: "auto",
          height: "90%",
        }}
      >

        <table
          className="table table-sm table-hover align-middle"
        >

          <thead>

            <tr>

              <th>Engineer</th>

              <th>Assigned</th>

              <th>Resolved</th>

              <th>Closed</th>

              <th>SLA %</th>

              <th>Feedback %</th>

              <th>Satisfaction %</th>

            </tr>

          </thead>

          <tbody>

            {data.length === 0 && (

              <tr>

                <td
                  colSpan="7"
                  className="text-center text-muted"
                >
                  No data available
                </td>

              </tr>

            )}

            {data.map(
              (row, index) => (

              <tr

                key={index}

                style={{
                  cursor: "pointer",
                }}

                onClick={() =>
                  onEngineerClick &&
                  onEngineerClick(
                    row.engineer
                  )
                }
              >

                <td>
                  {row.engineer}
                </td>

                <td>
                  {row.assigned}
                </td>

                <td>
                  {row.resolved}
                </td>

                <td>
                  {row.closed}
                </td>

                <td>
                  {row.sla_percentage}%
                </td>

                <td>
                  {row.feedback_percentage}%
                </td>

                <td>
                  {row.satisfaction_percentage}%
                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </DashboardCard>

  );
}